import authRules from '../authRules';

const liveSchedules = (user) => {
  const { scheduleView } = user.securityLevels;
  if (scheduleView >= authRules.liveSchedules.scheduleView) {
      return true;
  } else {
      return false;
    }
  }


export default liveSchedules;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/liveSchedules.js